"use client";

import { Link } from "react-router-dom";

export default function NeighborhoodCoverage() {
  const neighborhoods = [
    { name: "Brickell", slug: "brickell" },
    { name: "Aventura", slug: "aventura" },
    { name: "Miami Beach", slug: "miami-beach" },
    { name: "Coral Gables", slug: "coral-gables" },
    { name: "Coconut Grove", slug: "coconut-grove" },
    { name: "Doral", slug: "doral" },
    { name: "Kendall", slug: "kendall" },
    { name: "Pinecrest", slug: "pinecrest" },
    { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
    { name: "Key Biscayne", slug: "key-biscayne" },
    { name: "South Miami", slug: "south-miami" },
    { name: "North Miami Beach", slug: "north-miami-beach" },
  ];

  return (
    <section className="bg-cream py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-[28px] font-bold text-secondary text-center mb-8">
          Service Across Miami-Dade
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {neighborhoods.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="inline-flex items-center justify-center bg-cream border border-secondary/20 text-secondary text-sm font-medium py-2.5 px-4 rounded-[20px] hover:bg-primary hover:text-white transition-colors whitespace-nowrap"
            >
              {n.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}